const SESSION_KEY = "tv-session-token-v1";

const getApiBaseUrl = () => {
    if (process.env.REACT_APP_TV_API_BASE) {
        return process.env.REACT_APP_TV_API_BASE;
    }

    const hostname = String(window.location.hostname || "").toLowerCase();
    if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1") {
        return `${window.location.protocol}//${hostname}:3002/api/tv`;
    }

    return "/api/tv";
};

const API_BASE_URL = getApiBaseUrl();

const getSessionToken = () => window.localStorage.getItem(SESSION_KEY) || "";

const setSessionToken = (token) => {
    if (token) {
        window.localStorage.setItem(SESSION_KEY, token);
    } else {
        window.localStorage.removeItem(SESSION_KEY);
    }
};

const request = async (path, options = {}) => {
    const headers = new Headers(options.headers || {});
    const token = getSessionToken();

    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    if (options.body && !headers.has("Content-Type")) {
        headers.set("Content-Type", "application/json");
    }

    const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers });
    let payload = null;

    try {
        payload = await response.json();
    } catch (error) {
        payload = null;
    }

    if (!response.ok) {
        throw new Error((payload && payload.error) || "Request failed.");
    }

    return payload;
};

export const bootstrapTv = () => request("/bootstrap");

export const loginToTv = async ({ identifier, password }) => {
    const payload = await request("/login", {
        method: "POST",
        body: JSON.stringify({ identity: identifier, password }),
    });
    setSessionToken(payload.sessionToken);
    return payload;
};

export const requestTvAccess = ({ username, name, code }) =>
    request("/access-request", {
        method: "POST",
        body: JSON.stringify({ username, name, code }),
    });

export const createTvPassword = ({ token, password }) =>
    request("/create-password", {
        method: "POST",
        body: JSON.stringify({ token, password }),
    });

export const logoutFromTv = async () => {
    try {
        await request("/logout", { method: "POST" });
    } finally {
        setSessionToken("");
    }
};

export const fetchTvChannels = () => request("/channels");
